function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKowhaiwhai = function SvgKowhaiwhai(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 2000",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M122.002,2002.39l-113.24,-200.22l111.966,-200.353l-112.73,-199.504l112.544,-200.509l-112.629,-200.245l111.513,-204.385l-113.253,-198.123l115.235,-201.245l-113.52,-197.29l113.808,-197.455",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,1946.57c0,0 24.903,-32.702 18.742,-74.736c-6.197,-42.28 -35.785,-49.867 -61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,1546.34c0,0 24.903,-32.703 18.742,-74.737c-6.197,-42.279 -35.785,-49.866 -61.434,-42.551",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,1145.69c0,0 24.903,-32.703 18.742,-74.736c-6.197,-42.28 -35.785,-49.867 -61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,745.073c0,0 24.903,-32.702 18.742,-74.736c-6.197,-42.279 -35.785,-49.867 -61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,350.636c0,0 24.903,-32.702 18.742,-74.736c-6.197,-42.28 -35.785,-49.867 -61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,1654.67c0,0 24.903,32.703 18.742,74.737c-6.197,42.279 -35.785,49.866 -61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,1255c0,0 24.903,32.702 18.742,74.736c-6.197,42.28 -35.785,49.867 -61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,852.993c0,0 24.903,32.703 18.742,74.737c-6.197,42.279 -35.785,49.866 -61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,452.019c0,0 24.903,32.702 18.742,74.736c-6.197,42.279 -35.785,49.867 -61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467,52.9c0,0 24.903,32.702 18.742,74.736c-6.197,42.28 -35.785,49.867 -61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,1862.33c0,0 -24.903,32.702 -18.742,74.736c6.197,42.279 35.785,49.867 61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,1462.1c0,0 -24.903,32.702 -18.742,74.736c6.197,42.279 35.785,49.866 61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,1061.45c0,0 -24.903,32.702 -18.742,74.736c6.197,42.279 35.785,49.867 61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,660.833c0,0 -24.903,32.702 -18.742,74.736c6.197,42.28 35.785,49.867 61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,266.396c0,0 -24.903,32.702 -18.742,74.736c6.197,42.279 35.785,49.867 61.434,42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,1738.91c0,0 -24.903,-32.703 -18.742,-74.737c6.197,-42.279 35.785,-49.866 61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,1339.24c0,0 -24.903,-32.702 -18.742,-74.736c6.197,-42.279 35.785,-49.867 61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,937.234c0,0 -24.903,-32.703 -18.742,-74.737c6.197,-42.279 35.785,-49.866 61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,536.259c0,0 -24.903,-32.703 -18.742,-74.736c6.197,-42.28 35.785,-49.867 61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.435,137.14c0,0 -24.903,-32.702 -18.742,-74.736c6.197,-42.279 35.785,-49.867 61.434,-42.552",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,1846.89c-1.727,-2.505 -31.975,16.171 -17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,1446.67c-1.727,-2.505 -31.975,16.171 -17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,1046.01c-1.727,-2.505 -31.975,16.171 -17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,645.4c-1.727,-2.504 -31.975,16.171 -17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,250.963c-1.727,-2.505 -31.975,16.171 -17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,1754.34c-1.727,2.505 -31.975,-16.171 -17.725,-34.338",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,1354.67c-1.727,2.505 -31.975,-16.171 -17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,952.666c-1.727,2.505 -31.975,-16.171 -17.725,-34.338",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,551.692c-1.727,2.504 -31.975,-16.171 -17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,152.573c-1.727,2.505 -31.975,-16.171 -17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,1962c1.727,2.504 31.976,-16.171 17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,1561.78c1.727,2.505 31.976,-16.171 17.725,-34.338",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,1161.12c1.727,2.504 31.976,-16.171 17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,760.506c1.727,2.505 31.976,-16.171 17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,366.069c1.727,2.505 31.976,-16.171 17.725,-34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,1639.24c1.727,-2.505 31.976,16.171 17.725,34.338",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,1239.56c1.727,-2.504 31.976,16.171 17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,837.561c1.727,-2.505 31.976,16.171 17.725,34.338",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,436.586c1.727,-2.505 31.976,16.171 17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.462,37.467c1.727,-2.504 31.976,16.171 17.725,34.339",
    className: "main",
    style: {
      fill: "none",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,1829.39c1.951,-3.3 6.942,-3.701 11.138,-0.895c4.196,2.807 6.019,7.765 4.067,11.066c-1.951,3.3 -6.942,3.701 -11.138,0.894c-4.197,-2.806 -6.019,-7.765 -4.067,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,1429.17c1.951,-3.301 6.942,-3.701 11.138,-0.895c4.196,2.807 6.019,7.765 4.067,11.065c-1.951,3.301 -6.942,3.702 -11.138,0.895c-4.197,-2.807 -6.019,-7.765 -4.067,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,1028.51c1.951,-3.301 6.942,-3.701 11.138,-0.895c4.196,2.807 6.019,7.765 4.067,11.066c-1.951,3.3 -6.942,3.701 -11.138,0.894c-4.197,-2.807 -6.019,-7.765 -4.067,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,627.898c1.951,-3.3 6.942,-3.701 11.138,-0.894c4.196,2.806 6.019,7.765 4.067,11.065c-1.951,3.3 -6.942,3.701 -11.138,0.894c-4.197,-2.806 -6.019,-7.764 -4.067,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,233.461c1.951,-3.3 6.942,-3.701 11.138,-0.894c4.196,2.806 6.019,7.764 4.067,11.065c-1.951,3.3 -6.942,3.701 -11.138,0.894c-4.197,-2.806 -6.019,-7.765 -4.067,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,1771.85c1.951,3.301 6.942,3.702 11.138,0.895c4.196,-2.807 6.019,-7.765 4.067,-11.065c-1.951,-3.301 -6.942,-3.701 -11.138,-0.895c-4.197,2.807 -6.019,7.765 -4.067,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,1372.17c1.951,3.3 6.942,3.701 11.138,0.894c4.196,-2.806 6.019,-7.764 4.067,-11.065c-1.951,-3.3 -6.942,-3.701 -11.138,-0.894c-4.197,2.806 -6.019,7.765 -4.067,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,970.168c1.951,3.301 6.942,3.702 11.138,0.895c4.196,-2.807 6.019,-7.765 4.067,-11.065c-1.951,-3.301 -6.942,-3.701 -11.138,-0.895c-4.197,2.807 -6.019,7.765 -4.067,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,569.194c1.951,3.3 6.942,3.701 11.138,0.894c4.196,-2.807 6.019,-7.765 4.067,-11.065c-1.951,-3.3 -6.942,-3.701 -11.138,-0.895c-4.197,2.807 -6.019,7.765 -4.067,11.066Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.712,170.075c1.951,3.3 6.942,3.701 11.138,0.895c4.196,-2.807 6.019,-7.765 4.067,-11.066c-1.951,-3.3 -6.942,-3.701 -11.138,-0.894c-4.197,2.807 -6.019,7.765 -4.067,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,1979.5c-1.952,3.3 -6.943,3.701 -11.139,0.894c-4.196,-2.806 -6.019,-7.765 -4.067,-11.065c1.951,-3.3 6.942,-3.701 11.138,-0.894c4.197,2.806 6.019,7.764 4.068,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,1579.28c-1.952,3.3 -6.943,3.701 -11.139,0.894c-4.196,-2.807 -6.019,-7.765 -4.067,-11.065c1.951,-3.301 6.942,-3.701 11.138,-0.895c4.197,2.807 6.019,7.765 4.068,11.066Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,1178.62c-1.952,3.3 -6.943,3.701 -11.139,0.894c-4.196,-2.807 -6.019,-7.765 -4.067,-11.065c1.951,-3.3 6.942,-3.701 11.138,-0.895c4.197,2.807 6.019,7.765 4.068,11.066Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,778.008c-1.952,3.3 -6.943,3.701 -11.139,0.895c-4.196,-2.807 -6.019,-7.765 -4.067,-11.066c1.951,-3.3 6.942,-3.701 11.138,-0.894c4.197,2.806 6.019,7.765 4.068,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,383.571c-1.952,3.3 -6.943,3.701 -11.139,0.894c-4.196,-2.806 -6.019,-7.764 -4.067,-11.065c1.951,-3.3 6.942,-3.701 11.138,-0.894c4.197,2.806 6.019,7.764 4.068,11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,1621.74c-1.952,-3.301 -6.943,-3.702 -11.139,-0.895c-4.196,2.807 -6.019,7.765 -4.067,11.065c1.951,3.301 6.942,3.702 11.138,0.895c4.197,-2.807 6.019,-7.765 4.068,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,1222.06c-1.952,-3.3 -6.943,-3.701 -11.139,-0.894c-4.196,2.806 -6.019,7.765 -4.067,11.065c1.951,3.3 6.942,3.701 11.138,0.894c4.197,-2.806 6.019,-7.764 4.068,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,820.059c-1.952,-3.301 -6.943,-3.702 -11.139,-0.895c-4.196,2.807 -6.019,7.765 -4.067,11.065c1.951,3.301 6.942,3.702 11.138,0.895c4.197,-2.807 6.019,-7.765 4.068,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,419.084c-1.952,-3.301 -6.943,-3.701 -11.139,-0.895c-4.196,2.807 -6.019,7.765 -4.067,11.066c1.951,3.3 6.942,3.701 11.138,0.894c4.197,-2.807 6.019,-7.765 4.068,-11.065Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.191,19.965c-1.952,-3.3 -6.943,-3.701 -11.139,-0.894c-4.196,2.806 -6.019,7.765 -4.067,11.065c1.951,3.3 6.942,3.701 11.138,0.895c4.197,-2.807 6.019,-7.765 4.068,-11.066Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,1877.65c2.007,-1.658 5.253,-1.37 7.244,0.644c1.991,2.014 1.978,4.995 -0.03,6.653c-2.007,1.658 -5.253,1.37 -7.244,-0.644c-1.991,-2.013 -1.978,-4.994 0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,1477.43c2.007,-1.658 5.253,-1.37 7.244,0.644c1.991,2.013 1.978,4.994 -0.03,6.653c-2.007,1.658 -5.253,1.37 -7.244,-0.644c-1.991,-2.014 -1.978,-4.995 0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,1076.77c2.007,-1.658 5.253,-1.37 7.244,0.644c1.991,2.013 1.978,4.995 -0.03,6.653c-2.007,1.658 -5.253,1.37 -7.244,-0.644c-1.991,-2.013 -1.978,-4.995 0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,676.157c2.007,-1.658 5.253,-1.369 7.244,0.644c1.991,2.014 1.978,4.995 -0.03,6.653c-2.007,1.659 -5.253,1.37 -7.244,-0.643c-1.991,-2.014 -1.978,-4.995 0.03,-6.654Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,281.72c2.007,-1.658 5.253,-1.37 7.244,0.644c1.991,2.014 1.978,4.995 -0.03,6.653c-2.007,1.658 -5.253,1.37 -7.244,-0.644c-1.991,-2.013 -1.978,-4.994 0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,1723.59c2.007,1.659 5.253,1.37 7.244,-0.644c1.991,-2.013 1.978,-4.994 -0.03,-6.653c-2.007,-1.658 -5.253,-1.37 -7.244,0.644c-1.991,2.014 -1.978,4.995 0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,1323.91c2.007,1.658 5.253,1.37 7.244,-0.644c1.991,-2.014 1.978,-4.995 -0.03,-6.653c-2.007,-1.658 -5.253,-1.37 -7.244,0.644c-1.991,2.013 -1.978,4.994 0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,921.909c2.007,1.659 5.253,1.37 7.244,-0.644c1.991,-2.013 1.978,-4.994 -0.03,-6.653c-2.007,-1.658 -5.253,-1.369 -7.244,0.644c-1.991,2.014 -1.978,4.995 0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,520.934c2.007,1.659 5.253,1.37 7.244,-0.643c1.991,-2.014 1.978,-4.995 -0.03,-6.653c-2.007,-1.659 -5.253,-1.37 -7.244,0.643c-1.991,2.014 -1.978,4.995 0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,121.816c2.007,1.658 5.253,1.37 7.244,-0.644c1.991,-2.013 1.978,-4.995 -0.03,-6.653c-2.007,-1.658 -5.253,-1.37 -7.244,0.644c-1.991,2.013 -1.978,4.995 0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,1931.24c-2.007,1.658 -5.253,1.369 -7.244,-0.644c-1.991,-2.014 -1.978,-4.995 0.03,-6.653c2.007,-1.659 5.253,-1.37 7.244,0.643c1.991,2.014 1.978,4.995 -0.03,6.654Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,1531.02c-2.007,1.659 -5.253,1.37 -7.244,-0.643c-1.991,-2.014 -1.978,-4.995 0.03,-6.654c2.007,-1.658 5.253,-1.369 7.244,0.644c1.991,2.014 1.978,4.995 -0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,1130.36c-2.007,1.659 -5.253,1.37 -7.244,-0.643c-1.991,-2.014 -1.978,-4.995 0.03,-6.653c2.007,-1.659 5.253,-1.37 7.244,0.643c1.991,2.014 1.978,4.995 -0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,729.749c-2.007,1.658 -5.253,1.37 -7.244,-0.644c-1.991,-2.014 -1.978,-4.995 0.03,-6.653c2.007,-1.658 5.253,-1.37 7.244,0.644c1.991,2.013 1.978,4.994 -0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,335.312c-2.007,1.658 -5.253,1.37 -7.244,-0.644c-1.991,-2.014 -1.978,-4.995 0.03,-6.653c2.007,-1.658 5.253,-1.37 7.244,0.644c1.991,2.013 1.978,4.994 -0.03,6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,1670c-2.007,-1.658 -5.253,-1.37 -7.244,0.644c-1.991,2.013 -1.978,4.994 0.03,6.653c2.007,1.658 5.253,1.37 7.244,-0.644c1.991,-2.014 1.978,-4.995 -0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,1270.32c-2.007,-1.658 -5.253,-1.369 -7.244,0.644c-1.991,2.014 -1.978,4.995 0.03,6.653c2.007,1.659 5.253,1.37 7.244,-0.643c1.991,-2.014 1.978,-4.995 -0.03,-6.654Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,868.318c-2.007,-1.658 -5.253,-1.37 -7.244,0.644c-1.991,2.013 -1.978,4.994 0.03,6.653c2.007,1.658 5.253,1.37 7.244,-0.644c1.991,-2.014 1.978,-4.995 -0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,467.343c-2.007,-1.658 -5.253,-1.37 -7.244,0.644c-1.991,2.013 -1.978,4.995 0.03,6.653c2.007,1.658 5.253,1.37 7.244,-0.644c1.991,-2.013 1.978,-4.995 -0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.222,68.225c-2.007,-1.659 -5.253,-1.37 -7.244,0.643c-1.991,2.014 -1.978,4.995 0.03,6.653c2.007,1.659 5.253,1.37 7.244,-0.643c1.991,-2.014 1.978,-4.995 -0.03,-6.653Z",
    className: "main",
    style: {
      strokeWidth: 3
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKowhaiwhai, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Kowhaiwhai.d47eee6c.svg";
export { ForwardRef as ReactComponent };